/* eslint-disable no-undef */

import React, { PureComponent } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'
import { styles } from './index.styles'
import ApplicationElement from './components/ApplicationElement'
import Scoring from './components/Scoring'
import PageHeader from '../QuestionApplication/views/partials/PageHeader'

import { Grid, Typography } from '@material-ui/core'
import ReactGA from 'react-ga'
import { getConversionPage } from '../api'
import ApplicationRequestElement from './components/ApplicationRequestElement'
import DynamicButton from './components/DynamicButton'
import Footer from '../QuestionApplication/views/partials/Footer'

ReactGA.initialize(process.env.MIX_APP_ENV == 'local' ? '' : process.env.MIX_GA_TRACKING_CODE, { debug: false })

class ConversionApplication extends PureComponent {
    state = {
        isLoading: false,
        conversionPage: null,
        hash: null,
        visitorSessionId: null,
        hasPixels: false,
        iframeRefreshKey: 0
    }

    componentWillMount() {
        if (this.props.data && this.props.data.conversionPage) {
            this.setConversionPageState(this.props.data)
            this.trackPageview('/process/result-page')
        }
    }

    refresh = () => {
        this.setState({ isLoading: true })

        getConversionPage(this.state.hash).then(data => {
            this.setConversionPageState(data)
        })
    }

    setConversionPageState(data) {
        this.setState({
            isLoading: false,
            conversionPage: data.conversionPage,
            hash: data.hash,
            hasPixels: data.hasPixels,
            visitorSessionId: data.visitorSessionId
        })
    }

    trackPageview(url) {
        ReactGA.set({ page: url })
        ReactGA.pageview(url)
    }

    render() {
        const { classes, theme } = this.props
        const { conversionPage, visitorSessionId, hasPixels, iframeRefreshKey } = this.state

        if (!conversionPage) {
            return null
        }

        const elementContainer = conversionPage.elementContainer
        return (
            <>
                <div key={'questionApp'} className={classes.root + ' ConversionApplication-root'}>
                    <PageHeader />
                    <Grid container className={classes.container}>
                        <div className={classes.elementContainer}>
                            {elementContainer &&
                                elementContainer.map((elementItem, index) => {
                                    return (
                                        <div className={classes.elementItem}>
                                            <Grid
                                                container
                                                className={
                                                    classes.header +
                                                    ' ConversionApplication-header ' +
                                                    (elementItem.elements || true ? classes.headerWithOffers : null)
                                                }
                                            >
                                                <Grid item xs={12} sm={12} className={classes.contentWrapper}>
                                                    <Typography
                                                        component="h1"
                                                        variant={elementItem.titleSize}
                                                        className={classes.title + ' ConversionApplication-title'}
                                                    >
                                                        {elementItem.title && elementItem.title.length > 0 && parse(elementItem.title)}
                                                    </Typography>
                                                    {elementItem.description && elementItem.description.length > 0 && (
                                                        <Typography
                                                            variant="body1"
                                                            align="center"
                                                            color="textSecondary"
                                                            className={classes.description + ' ConversionApplication-description'}
                                                        >
                                                            {parse(elementItem.description)}
                                                        </Typography>
                                                    )}
                                                </Grid>
                                            </Grid>
                                            {elementItem.elements &&
                                                elementItem.elements.map((element, key) => <ApplicationElement element={element} />)}
                                            {!elementItem.elements && elementItem.button && <DynamicButton button={elementItem.button} />}

                                            {!elementItem.elements && elementItem.allElements && (
                                                <ApplicationRequestElement
                                                    elements={elementItem.allElements}
                                                    priorityClient={elementItem.priorityClient}
                                                    autoRefresh={elementItem.autoRefresh}
                                                />
                                            )}

                                            {elementItem.scoring && (
                                                <Scoring
                                                    first={elementItem.scoring.first}
                                                    second={elementItem.scoring.second}
                                                    third={elementItem.scoring.third}
                                                />
                                            )}
                                        </div>
                                    )
                                })}
                        </div>
                    </Grid>
                    {hasPixels && (
                        <iframe
                            src={process.env.MIX_API_URL + '/pixels?vs=' + visitorSessionId}
                            key={iframeRefreshKey}
                            style={{
                                width: 0,
                                height: 0,
                                border: 'none',
                                position: 'absolute'
                            }}
                        />
                    )}
                </div>
                {theme?.domain === 'hae.rahoo.fi' && <Footer />}
            </>
        )
    }
}

export default withStyles(styles)(ConversionApplication)
